/**
 * Owner: Haselton Baker Risk Group, LLC
 * Copyright All Rights Reserved
 */
import defaultTo from 'lodash/fp/defaultTo.js';
import { connect } from 'react-redux';
import {
  COMPONENT_SOFT_COST_MODIFIER,
  DATE_COST_MULTIPLIER,
  LOCATION_CAPACITY_MODIFIER,
  LOCATION_COST_MODIFIER,
  LOCATION_TIME_MODIFIER,
  OCCUPANCY_COST_MULTIPLIER,
  REGION_COST_MULTIPLIER,
} from '@hbrisk/sp3-risk-model-support/models/app/attributes/names/index.js';
import { modelTypesByForm } from '#src/js/constants/models/modelTypes/index.js';
import { selectRunBuildingValueModifier, currentModelId } from '#selectors/entities/models.js';
import ScaleFactor from './ScaleFactor.jsx';

const mapStateToProps = (state, ownProps) => {
  const { form, locationItem } = ownProps;
  const { selectFormValues } = modelTypesByForm[form];

  const modelId = currentModelId(state);

  const costModifier = defaultTo(
    1,
    selectFormValues(state, `${locationItem}.${LOCATION_COST_MODIFIER}`)
  );
  const capacityModifier = defaultTo(
    1,
    selectFormValues(state, `${locationItem}.${LOCATION_CAPACITY_MODIFIER}`)
  );
  const timeModifier = defaultTo(
    1,
    selectFormValues(state, `${locationItem}.${LOCATION_TIME_MODIFIER}`)
  );
  const regionCostMultiplier = defaultTo(1, selectFormValues(state, REGION_COST_MULTIPLIER));
  const dateCostMultiplier = defaultTo(1, selectFormValues(state, DATE_COST_MULTIPLIER));
  const occupancyCostMultiplier = defaultTo(1, selectFormValues(state, OCCUPANCY_COST_MULTIPLIER));
  const componentSoftCostModifier = defaultTo(
    1,
    selectFormValues(state, COMPONENT_SOFT_COST_MODIFIER)
  );

  const buildingValueModifier = defaultTo(1, selectRunBuildingValueModifier(state, { modelId }));

  return {
    costModifier,
    capacityModifier,
    timeModifier,
    regionCostMultiplier,
    dateCostMultiplier,
    occupancyCostMultiplier,
    buildingValueModifier,
    componentSoftCostModifier,
  };
};

export default connect(mapStateToProps)(ScaleFactor);
